import { render, staticRenderFns } from "./myaccount-dashboard-header.vue?vue&type=template&id=818952ae"
import script from "./myaccount-dashboard-header.vue?vue&type=script&lang=js"
export * from "./myaccount-dashboard-header.vue?vue&type=script&lang=js"
import style0 from "./myaccount-dashboard-header.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports